import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { isFirefox } from '../../../utils/BrowserTest';
import { TruncateString } from '../../TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
export const SortTH_TruncateString = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(TruncateString, Object.assign({
    inlineSize: isFirefox() ? 'calc(100% - 14px)' : undefined
  }, props, {
    children: children
  }));
};